<template>
  <div class="flickitySlider">
    <Flickity :options="flickityOptions" @ready="flickityReady" @change="flickityChange" @scroll="flickityScroll" :class="customClass">
      <slot />
    </Flickity>
    
    <div v-if="withProgress" class="flickitySlider__ProgressWrapper" ref="sliderWrapper">
      <div class="flickitySlider__Bar" ref="sliderBar" :style="`width: ${slider ? 100 / slider.cells.length : 100}%; transform: translateX(${ progress }px)`"></div>
    </div>
  </div>
</template>

<script setup>
  const slider = ref(null);
  const sliderWrapper = ref(null);
  const sliderBar = ref(null);
  const activeSlide = ref(0);
  const progress = ref(0);
  const sliderWrapperWidth = ref(0);
  const sliderBarWidth = ref(0);
  const props = defineProps({
    withProgress: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    customClass: '',
  });
  const emit = defineEmits(['ready'])

  const flickityOptions = computed(() => {
    if (Object.keys(props.options)) {
      return {
        ...props.options,
        dragTreshold: 40,
      };
    } else {
      return {
        prevNextButtons: false,
        watchCSS: false,
        pageDots: true,
        dragTreshold: 40,
      };
    }
  })

  function flickityReady(_flickity) {
    if (props.withProgress) {
      setTimeout(() => {
        getProgressDimensions();
      }, 10);
    }
    slider.value = _flickity;
    emit('ready', _flickity);
  }

  function flickityChange(index) {
    if (props.withProgress) getProgressDimensions();
    activeSlide.value = index;
  }

  function flickityScroll(value) {
    if (props.withProgress) progress.value = ((sliderWrapperWidth.value - sliderBarWidth.value) * value).toFixed(2);
  }

  function getProgressDimensions() {
    sliderWrapperWidth.value = sliderWrapper.value.offsetWidth || 0;
    sliderBarWidth.value = sliderBar.value.offsetWidth || 0;
  }
</script>

<style lang="scss">
  @import url('@/assets/styles/components/_flickitySlider.scss');
</style>